import { create } from 'zustand'
import type { Opportunity, OpportunityDetail } from '@/types'

interface OpportunityState {
  opportunities: Opportunity[]
  currentOpportunity: OpportunityDetail | null
  loading: boolean
  error: string | null
  statusFilter: string
  sourceFilter: string
  matchFilter: string
  rfpQueueCount: number

  setOpportunities: (opps: Opportunity[]) => void
  setCurrentOpportunity: (opp: OpportunityDetail | null) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  setStatusFilter: (status: string) => void
  setSourceFilter: (filter: string) => void
  setMatchFilter: (filter: string) => void
  removeOpportunity: (id: string) => void
  updateOpportunityInList: (id: string, updates: Partial<Opportunity>) => void
  setRfpQueueCount: (count: number) => void
}

export const useOpportunityStore = create<OpportunityState>((set) => ({
  opportunities: [],
  currentOpportunity: null,
  loading: false,
  error: null,
  statusFilter: '',
  sourceFilter: 'all',
  matchFilter: 'all',
  rfpQueueCount: 0,

  setOpportunities: (opportunities) => set({ opportunities }),
  setCurrentOpportunity: (currentOpportunity) => set({ currentOpportunity }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setSourceFilter: (sourceFilter) => set({ sourceFilter }),
  setMatchFilter: (matchFilter) => set({ matchFilter }),
  removeOpportunity: (id) =>
    set((state) => ({
      opportunities: state.opportunities.filter((o) => o.id !== id),
    })),
  updateOpportunityInList: (id, updates) =>
    set((state) => ({
      opportunities: state.opportunities.map((o) =>
        o.id === id ? { ...o, ...updates } : o
      ),
    })),
  setRfpQueueCount: (rfpQueueCount) => set({ rfpQueueCount }),
}))
